import {
  Avatar,
  Box,
  Center,
  Flex,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Select,
  Spacer,
  Text,
} from "@chakra-ui/react";
import React, { FC } from "react";
import { observer } from "mobx-react-lite";
import NotificationsStore from "../../stores/data/notifications/notificationsStore";
import NotificationDropdown from "../NotificationDropdown";

import { useTranslation } from "react-i18next";
import { Link, useHistory } from "react-router-dom";
import flagBrazil from "../../assets/flag-brazil.svg";
import flagUk from "../../assets/flag-uk.svg";
import flagSpain from "../../assets/flag-spain.svg";
import OccurrenceStore from "../../stores/data/occurrence/occurrenceStore";
import AuthStore from "stores/data/Auth/AuthStore";
import { Clock } from "lucide-react";
interface Props {
  handleLogout: () => void;
  notificationsStore: NotificationsStore;
  name: string;
  handleChangeLanguage: (language: string) => void;
  occurrenceStore: OccurrenceStore;
  authStore: AuthStore;
  timezone: string;
}

const Header: FC<Props> = ({
  notificationsStore,
  handleLogout,
  name,
  handleChangeLanguage,
  timezone,
}: Props) => {
  const { i18n } = useTranslation();
  let history = useHistory();

  return (
    <Flex
      as="header"
      alignItems="center"
      p={1}
      color="blue.900"
      bg="white"
      boxShadow={"0px 4px 10px rgba(30, 24, 83, 0.13)"}
    >
      <Center gap={2} px={"37px"}>
        <Clock size="16px" />
        <Text
          color="#0E337B"
          mt="4px"
          fontSize={"xs"}
          cursor="pointer"
          _hover={{ textDecoration: "underline" }}
          onClick={() => history.push("/settings")}
        >
          {timezone}
        </Text>
      </Center>

      <Spacer />
      <Flex justifyContent="flex-end">
        <Center
          pl={2}
          borderRadius={8}
          _hover={{ bg: "gray.100" }}
          _focus={{ boxShadow: "outline" }}
          border="none"
        >
          <Box>
            {i18n.resolvedLanguage === "pt-BR" ? (
              <img src={flagBrazil} alt="Brazil" height="23px" width="23px" />
            ) : i18n.resolvedLanguage === "es" ? (
              <img src={flagSpain} alt="Spain" height="23px" width="23px" />
            ) : (
              <img src={flagUk} alt="UK" height="23px" width="23px" />
            )}
          </Box>

          <Select
            size="sm"
            value={i18n.resolvedLanguage}
            onChange={(e) => handleChangeLanguage(e.target.value)}
            _focus={{ boxShadow: "outline" }}
            border="none"
          >
            <option style={{ color: "blue.100" }} value="pt-BR">
              {i18n.t("navBar.portuguese")}
            </option>
            <option style={{ color: "black" }} value="en">
              {i18n.t("navBar.english")}
            </option>
            <option style={{ color: "black" }} value="es">
              {i18n.t("navBar.spanish")}
            </option>
          </Select>
        </Center>
        <Box>
          <NotificationDropdown
            notifications={notificationsStore.notifications}
            countNoReadNotifications={
              notificationsStore.countNoReadNotifications
            }
          />
        </Box>
        <Menu>
          <MenuButton
            _hover={{ bg: "gray.100" }}
            _focus={{ boxShadow: "outline" }}
            borderRadius={8}
          >
            <Center
              mr={8}
              _hover={{ bg: "gray.400" }}
              _expanded={{ bg: "blue.400" }}
              paddingX={2}
              paddingY={1}
            >
              <Avatar size="xs" />
              <Center ml={2} gap={2}>
                <Text>{name}</Text>
                <Box
                  w={0}
                  h={0}
                  borderLeft="5px solid transparent"
                  borderRight="5px solid transparent"
                  borderTop="5px solid"
                ></Box>
              </Center>
            </Center>
          </MenuButton>
          <MenuList zIndex={999999999999}>
            <Link to="/admin/my-data">
              <MenuItem as="div">
                <Text color="blue.100">{i18n.t("navBar.myData")}</Text>
              </MenuItem>
            </Link>
            <Link to="/admin/change-password">
              <MenuItem as="div">
                <Text color="blue.100">{i18n.t("navBar.changePassword")}</Text>
              </MenuItem>
            </Link>
            <MenuItem as="button" onClick={handleLogout}>
              <Text color="blue.100">{i18n.t("navBar.logout")}</Text>
            </MenuItem>
          </MenuList>
        </Menu>
      </Flex>
    </Flex>
  );
};

export default observer(Header);
